import { createReducer } from '@reduxjs/toolkit'
import { setTotalElements, setTotalPages, clearLlistat } from '../actions/LlistatAction'

export interface LlistatState {
  totalElements?: number
  totalPages?: number
}

const initialLlistatState: LlistatState = {
  totalElements: 0,
  totalPages: 0
}

const llistatReducer = createReducer(initialLlistatState, (builder) => {
  builder
    .addCase(setTotalElements, (state, action) => {
      state.totalElements = action.payload
    })
    .addCase(setTotalPages, (state, action) => {
      state.totalPages = action.payload
    })
    .addCase(clearLlistat, (state) => {
      state.totalElements = 0
      state.totalPages = 0
    })
})

export default llistatReducer
